export const cardVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  hover: { 
    y: -4,
    transition: { duration: 0.2 }
  }
};

export const transition = {
  duration: 0.5,
  ease: [0.56, 0.03, 0.12, 1.04]
};

export const variants = {
  initial1: {
    width: '100%'
  },
  animate1: {
    width: '50%'
  },
  initial2: {
    left: '100%'
  },
  animate2: {
    left: '50%'
  }
};

export const sortMenuVariants = {
  closed: {
    width: 'fit-content',
    transition: {
      duration: 0.3,
      ease: [0.56, 0.03, 0.12, 1.04]
    }
  },
  open: {
    width: 'fit-content',
    transition: {
      duration: 0.3,
      ease: [0.56, 0.03, 0.12, 1.04]
    }
  }
};

export const sortButtonsVariants = {
  closed: {
    opacity: 0,
    width: 0,
    marginLeft: 0,
    transition: {
      duration: 0.2,
      ease: 'easeInOut'
    }
  },
  open: {
    opacity: 1,
    width: 'auto',
    marginLeft: '0.75rem',
    transition: {
      duration: 0.3,
      delay: 0.1,
      ease: 'easeOut'
    }
  }
};
